// extracted by mini-css-extract-plugin
export var disclaimer = "TermsAndConditions_disclaimer__kYpc0";
export var pactSafeContainer = "TermsAndConditions_pactSafeContainer__mFKMY";
export var shippingDisclaimer = "TermsAndConditions_shippingDisclaimer__f1Svs";
export var termsAndConditions = "TermsAndConditions_termsAndConditions__NQZXx";
export var termsAndConditionsWrapper = "TermsAndConditions_termsAndConditionsWrapper__XkIUX";